import React, { ReactNode } from 'react';
import { SiteLayout } from './SiteLayout';
type PolicyPageLayoutProps = {
  title: string;
  children: ReactNode;
};
export function PolicyPageLayout({
  title,
  children
}: PolicyPageLayoutProps) {
  return <SiteLayout data-id="element-453" data-mp="197d28jzgcyp1">
      <main className="mx-auto max-w-4xl px-4 py-10 md:py-14" data-id="element-454" data-mp="197mr248rgzt5">
        <article className="border-t-4 border-brand-red bg-white pt-6" data-id="element-455" data-mp="1e4da90fv4bis">
          <h1 className="text-3xl font-bold text-brand-charcoal md:text-4xl" data-id="element-456" data-mp="21ur0clew00aq">{title}</h1>
          <div className="mt-7 space-y-6 leading-7 text-gray-700" data-id="element-457" data-mp="21swdv2nyw04j">{children}</div>
        </article>
      </main>
    </SiteLayout>;
}